namespace $.$$ {

	$mol_style_define( $bog_merchquarium_carousel, {
		Image: {
			objectFit: 'cover',
		},
		'::scroll-marker-group': {
        	height: 'auto',
         	padding: { top: $mol_gap.block },
		},
	} )

}
